import { createIconSetFromIcoMoon } from '@expo/vector-icons';


const Icon = createIconSetFromIcoMoon(
  require('../assets/fonts/icomoon/selection.json'),
  'IcoMoon',
  'icomoon.ttf'
);

export default Icon;